import { render } from "./TemplateModal.vue?vue&type=template&id=6efd9a89&ts=true"
import script from "./TemplateModal.vue?vue&type=script&lang=ts"
export * from "./TemplateModal.vue?vue&type=script&lang=ts"

import "./TemplateModal.vue?vue&type=style&index=0&id=6efd9a89&lang=css"

import exportComponent from "C:\\BuildAgent\\work\\7605b49a72e2e39\\AutoProc\\Solution\\Clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__